import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconTextFormatStyle0 = cosmosIconCss;

const CosmosIconTextFormat$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTextFormat extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'b6fdabf530dc4502fe1d71fbaa56ed89d9437e5a', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6e0b15797f885b8c7aa3fb742ed032477a00bee4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ce4e9eeeccccc97605cf7e689ec4f84566394215', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12 5.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5h-6A.5.5 0 0 1 12 6v-.5ZM7.137 9.225H5.508l.81-2.618.819 2.618Zm-2.009 1.2h2.385l.343 1.049a.4.4 0 0 0 .38.276h.898a.3.3 0 0 0 .266-.439L7.284 5.354a.5.5 0 0 0-.47-.329h-1a.5.5 0 0 0-.47.328l-2.109 5.962a.3.3 0 0 0 .265.439h.892a.4.4 0 0 0 .379-.272l.357-1.057Zm7.372-.175a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-6Zm-9 5.25a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5V16a.5.5 0 0 0-.5-.5h-15Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconTextFormatStyle0; }
}, [1, "cosmos-icon-text-format", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-text-format"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-text-format":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTextFormat$1);
            }
            break;
    } });
}

const CosmosIconTextFormat = CosmosIconTextFormat$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTextFormat, defineCustomElement };
